import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { Botao, Spacer, TextAreaUnform } from 'src/componentes'
import { ModalBase } from 'src/componentes/modal-base'
import { FormUnform } from 'src/componentes/unform/form'
import { Api } from 'src/servicos'

import { AcoesModal, Corpo } from './styles'

export interface ModalCancelarRef {
  abrir: () => void
  fechar: () => void
}

interface ModalCancelarProps {
  backdrop?: boolean
  condicaoId: string
  aoCancelar: () => void
}

/**
 * Cancelamento da condição especial. O motivo é obrigatório — o backend exige
 * e ele vai para o histórico de status.
 */
const Modal: React.ForwardRefRenderFunction<
  ModalCancelarRef,
  ModalCancelarProps
> = ({ backdrop, condicaoId, aoCancelar }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [carregando, definirCarregando] = useState(false)

  // Sem essa key o Unform retém valores de aberturas anteriores do modal.
  const [chaveFormulario, definirChaveFormulario] = useState(0)

  const fechar = () => definirAberta(false)

  const abrir = () => {
    definirChaveFormulario(chave => chave + 1)
    definirAberta(true)
  }

  useImperativeHandle<ModalCancelarRef, ModalCancelarRef>(ref, () => ({
    abrir,
    fechar
  }))

  const acaoSucesso = async (dados: { motivo: string }) => {
    if (!dados.motivo?.trim()) return

    try {
      definirCarregando(true)
      await Api.CancelarCondicaoEspecial(condicaoId, dados.motivo.trim())
      fechar()
      aoCancelar()
    } catch {
      // Mensagens do backend já viram toast no interceptor.
    } finally {
      definirCarregando(false)
    }
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop} id="modal-cancelar-condicao">
      <Corpo>
        <h5>Cancelar condição especial</h5>
        <p>
          O link deixa de funcionar e o aluno não conseguirá mais se matricular
          por ele. O registro é mantido no histórico. Esta ação não pode ser
          desfeita.
        </p>
        <Spacer padding="10px 0px" />
        <FormUnform key={chaveFormulario} acaoSucesso={acaoSucesso}>
          <TextAreaUnform
            id="ipt_motivo_cancelamento"
            name="motivo"
            label="Motivo do cancelamento"
            obrigatorio
            maxLength={500}
          />
          <Spacer padding="10px 0px" />
          <AcoesModal>
            <Botao
              type="button"
              id="btn-nao-cancelar"
              texto="Voltar"
              tema="Secundario"
              disabled={carregando}
              onClick={fechar}
            />
            <Botao
              id="btn-confirmar-cancelamento"
              texto="Cancelar condição"
              type="submit"
              carregando={carregando}
            />
          </AcoesModal>
        </FormUnform>
      </Corpo>
    </ModalBase>
  )
}

export const ModalCancelar = forwardRef(Modal)
